import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d4x38vshjr: FaireBrandEntity = {
  token: "b_d4x38vshjr",
  type: "brand",
  name: "LollyBanks",
  avatarUrl:
    "https://cdn.faire.com/fastly/88bec2d61b9dbc05fbbbb3537cdb87a9818e0b716a191a5c304ace526bfd2156.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e32bb2c37988215e663f814d88082096a54964e7fe0aaa179c973b121f173c0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/88bec2d61b9dbc05fbbbb3537cdb87a9818e0b716a191a5c304ace526bfd2156.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e32bb2c37988215e663f814d88082096a54964e7fe0aaa179c973b121f173c0.png",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 414,
  isTopShop: true,
  isInsider: true,
  description:
    'LollyBanks, a heartwarming brand born from the dreams and love of three women in Charlotte, NC! We take pride in offering a delightful selection of high-quality, enchanting baby blankets and products that won\'t break the bank. \n\nAt LollyBanks, our commitment to excellence shines through in every detail. Each pattern is thoughtfully handcrafted by our talented artist, ensuring that every design is unique and captivating. We take the safety of your precious bundles seriously, which is why all our products are proudly OEKO-TEX® Standard 100 Certified, guaranteeing that they are free from harmful substances.\n\nThe name "LollyBanks" holds a special place in our hearts, as it is a sweet reminder of our family\'s youngest member, Banks. When he was just two years old, he affectionately called Aunt Laura "Lolly." His adorable innocence and affectionate nature captured the hearts of everyone in our extended family. We cherish these tender moments and strive to infuse that same joy and love into each of our products.\n\nLollyBanks invites you to go beyond purchasing baby blankets – become a cherished part of our family. Join us in crafting a realm of comfort, imagination, and delight for the little ones. We appreciate your choice of LollyBanks to grace your store!\n\nTerms Of Service: https://docs.google.com/document/d/1AWw11fIPJLZ9iueRpoupJMQqS18RrB2W6zrcIE9BXQw/edit?usp=sharing',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:36.638Z",
    importedBy: "entity-db-cli",
  },
};
